export default __webpack_public_path__ + "static/uiux1-ea37632c1c48dc8399ae064478dbe3bd.jpg";